import { Logo } from "@/components/Logo";

export const Footer = () => {
    return (
        <footer className="mt-32 bg-ink text-sand">
            <div className="mx-auto grid max-w-6xl gap-12 px-6 py-16 md:grid-cols-4">
                <div className="md:col-span-2">
                    <Logo invert />
                    <p className="mt-5 max-w-sm font-light text-sand/70 leading-relaxed">
                        Werighty turns travel research into a single graceful moment.
                        AI-curated hotels, restaurants and itineraries, with realistic costs in your pocket.
                    </p>
                </div>
                <div>
                    <p className="overline mb-4 text-sand/60">Product</p>
                    <ul className="space-y-2 text-sm text-sand/80">
                        <li><a href="/#explore" className="hover:text-terracotta">Explore</a></li>
                        <li><a href="/#how" className="hover:text-terracotta">How it works</a></li>
                        <li><a href="/#popular" className="hover:text-terracotta">Destinations</a></li>
                    </ul>
                </div>
                <div>
                    <p className="overline mb-4 text-sand/60">Account</p>
                    <ul className="space-y-2 text-sm text-sand/80">
                        <li><a href="/login" className="hover:text-terracotta">Login</a></li>
                        <li><a href="/register" className="hover:text-terracotta">Sign up</a></li>
                        <li><a href="/dashboard" className="hover:text-terracotta">Dashboard</a></li>
                    </ul>
                </div>
            </div>
            <div className="border-t border-sand/10 px-6 py-6">
                <p className="mx-auto max-w-6xl text-xs text-sand/50">
                    © {new Date().getFullYear()} Werighty — Travel, simplified.
                </p>
            </div>
        </footer>
    );
};

export default Footer;
